import React from "react";
import { useTheme } from "@mui/material/styles";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import { Container } from "@mui/material";
import logo from "../../images/JSB_Logo_latest.png";
import { Helmet } from "react-helmet";

import initialBackground from "../../images/nakshatra-veda-mobile-01- .webp";
import secondBackground from "../../images/nakshatra-aaztha-mobile-02.webp";
import thirdBackground from "../../images/nakshatra-prithvi-mobile-03.webp";
import fourthBackground from "../../images/nakshatra-gokul-mobile-04.webp";
import FifthBackground from "../../images/nakshatra-auris-mobile-05.webp";

import "../../styles/MobileHomePage.css";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const images = [
  { url: initialBackground, text: "Nakshatra Veda I & II, Vasai", alt: "Nakshatra Veda residential project exterior view" },
  { url: secondBackground, text: "Aazstha, Vasai", alt: "Nakshatra Aaztha luxury apartments " },
  { url: thirdBackground, text: "Nakshatra Prithvi, Vasai", alt: "Nakshatra Prithvi eco-friendly homes " },
  { url: fourthBackground, text: "Nakshatra Gokul, Virar", alt: "Nakshatra Gokul premium housing development " },
  { url: FifthBackground, text: "Nakshatra Auris, Nalasopara", alt: "Nakshatra Auris modern living spaces" },
  { url: initialBackground, text: "Nakshatra Veda I & II, Vasai", alt: "Nakshatra Veda residential project exterior view" },
  { url: secondBackground, text: "Aazstha, Vasai", alt: "Nakshatra Aaztha luxury apartments " },
  { url: thirdBackground, text: "Nakshatra Prithvi, Vasai", alt: "Nakshatra Prithvi eco-friendly homes " },
  { url: fourthBackground, text: "Nakshatra Gokul, Virar", alt: "Nakshatra Gokul premium housing development " },
  { url: FifthBackground, text: "Nakshatra Auris, Nalasopara", alt: "Nakshatra Auris modern living spaces" },
];

const MobileHomePage = ({ scrollToSection }) => {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <div className="mobile-homepage">
      <Helmet>
        <title>
          Top 10 Real Estate Developers in Mumbai | JSB Homemakers
        </title>
        <meta
          name="description"
          content="JSB Homemakers, one of the top 10 real estate developers in Mumbai and among the biggest in India, is offering premium homes. Book your dream property today"
        />
      </Helmet>
      <AutoPlaySwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
        interval={3000}
        className="mobile-carousel"
      >
        {images.map((image, index) => (
          <div
            key={index}
            className="mobile-carousel-item"
            style={{
              backgroundImage: `url(${image.url})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: "100vh",
            }}
          >
            <img
              src={image.url}
              alt={image.alt}
              loading="lazy"
              className="mobile-carousel-image"
             
            />
          </div>
        ))}
      </AutoPlaySwipeableViews>

      <header className="mobile-header">
        <img 
          src={logo} 
          alt="Logo" 
          className="mobile-logo" 
          loading="lazy" 
        />
      </header>

      <Container className="mobile-content">
        <h5 className="mobile-headline">
          WHERE <br />
          <h5 className="mobile-highlight">
            QUALITY <br />
          </h5>
          MEETS YOUR <br />
          <h5 className="mobile-highlight">DREAMS </h5>
        </h5>

        <br />
        <div className="mobile-text-above-button">
          <p>{images[activeStep].text}</p>
        </div>
        <button
          className="mobile-enquire-button"
          onClick={() => scrollToSection()}
        >
          ENQUIRE NOW
        </button>
      </Container>
    </div>
  );
};

export default MobileHomePage;